export default [
  {
    path: '/policy/policyLibrary/policyDictionary',
    name: 'PolicyDictionary',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/policyDictionary/index.vue`),
    meta:{
      title: '政策字典',
      permission: ['policy_library_index']
    }
  },
  {
    path: '/policy/policyLibrary/policyExpress',
    name: 'PolicyExpress',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/policyExpress/index.vue`),
    meta:{
      title: '政策速递',
      permission: ['policy_express']
    }
  },
  {
    path: '/policy/policyLibrary/industryReport',
    name: 'IndustryReport',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/industryReport/index.vue`),
    meta:{
      title: '行业报告',
      permission: ['industry_report']
    }
  },
  {
    path: '/policy/policyLibrary/documentTemplate',
    name: 'DocumentTemplate',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/documentTemplate/index.vue`),
    meta:{
      title: '文档模板',
      permission: ['business_template_document']
    }
  },
  {
    path: '/policy/policyLibrary/guidance',
    name: 'Guidance',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/policy/policyLibrary/guidance/index.vue`),
    meta:{
      title: '办事指南',
      permission: ['business_template_work_guide']
    }
  }
]
